import { HStack, Text, VStack } from '@ayble-health/dashboard-components';
import { Box, Image } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';

import { useUserCareTeam } from '../../api/healthCoach/useUserCareTeam';
import { DEFAULT_AVATAR_IMG_URL } from '../HealthCoachDashboard/constants';

export const UserCareTeam = () => {
  const { patient } = useParams();

  const { data: careTeamMembers } = useUserCareTeam(patient || '');

  return (
    <VStack pt={4} px={1}>
      <Text
        color={'blueGray.600'}
        fontSize={'md'}
        fontWeight={'normal'}
        textAlign="left"
      >
        Care Team
      </Text>

      {careTeamMembers?.map(({ display_name, image_url, type }) => (
        <Box p={2} my={1} borderRadius={8} bgColor={'feather.100'}>
          <HStack maxW={'100%'}>
            <VStack flex={1}>
              <Text fontSize={'md'} fontWeight={600} color={'secondary.200'}>
                {display_name}
              </Text>
              <Text color={'blueGray.600'} fontWeight={400}>
                {type}
              </Text>
            </VStack>

            <Box w={8} h={8} rounded={'full'} overflow={'hidden'}>
              <Image
                alt={'Care Team Member Avatar'}
                w={'100%'}
                h={'100%'}
                src={image_url || DEFAULT_AVATAR_IMG_URL}
              />
            </Box>
          </HStack>
        </Box>
      ))}
    </VStack>
  );
};
